import { styled, Paper, Button } from '@mui/material'

export const Header = styled(Paper)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${
    theme.palette.primary.dark || theme.palette.primary.main
  } 100%)`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '3.6em',
  paddingLeft: '16px',
  borderRadius: '20px 20px 0 0',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
    pointerEvents: 'none',
  },
}))

export const Text = styled('div')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '15px',
  textAlign: 'center',
  color: theme.palette.text.primary,
}))

export const ButtonCustom = styled(Button)(({ theme }) => ({
  height: '30px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontSize: '12px',
  fontWeight: 600,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  borderRadius: '8px',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark || theme.palette.primary.main,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  },
  '&:active': {
    transform: 'translateY(0)',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
  },
}))
